<template>
    <main :class="{'page-news-detail--no-background' : !background}" class="page-news-detail app__main">
        <div v-if="background"
             :style="{ 'background-image': `url(${background})` }"
             class="page-news-detail__background"
        ></div>

        <a v-if="pdfFileExists"
           :href="pdfFile"
           target="_blank"
           class="page-news-detail__mobile-pdf-download"
        >Télécharger le PDF</a>

        <slot name="article-content"></slot>
    </main>
</template>

<script>
    import Mantel from '@/components/Mantel';
    import newsDetailsFilesMixin from '@/mixins/news-details-files';

    export default {
        name: 'PageNewsDetail',

        components: {
            Mantel,
        },

        mixins: [ newsDetailsFilesMixin ],

        props: {
            background: { type: String, default: null },
        },
    };
</script>

<style lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_mixins';

    .page-news-detail {

        &__background {
            @include size(100%, 18.8rem);
            background-size: cover;
            background:      no-repeat top center;

            @include media-breakpoint-up(sm) {
                @include size(100%, 49rem);

            }
        }

        &__mobile-pdf-download {
            display:         flex;
            flex-direction:  row;
            justify-content: center;
            align-items:     center;

            @include size(100%, 3.1rem);
            color:           white;
            font-size:       1.2rem;

            background:      $gray-600;

            &:hover {
                color: white;
            }

            &::before {
                content:      url('~@/assets/images/download-white.png');
                position:     relative;
                top:          0.2rem;

                margin-right: 1rem;
            }

            @include media-breakpoint-up(sm) {
                display: none;
            }
        }

        @include media-breakpoint-up(sm) {
            &:not(&--no-background) &__content {
                margin-top: -18.7rem;
            }

            &--no-background &__content {
                margin-top: 10rem;
            }
        }
    }
</style>
